import * as yup from 'yup';
/** Merchant Registrative Session */
export const BillPayRequestSchema = yup
    .object({
    accountHolderCode: yup.string().max(36).required(),
    invoiceDescription: yup.string().required(),
    paymentAmount: yup.number().required(),
    fullName: yup.string().required(),
    email: yup.string().email().required(),
    phoneNumber: yup.string().optional(),
    address1: yup.string().optional(),
    address2: yup.string().optional(),
    city: yup.string().optional(),
    stateId: yup.number().optional(),
    zipCode: yup.string().optional(),
    bankName: yup.string().optional(),
    accountHolderName: yup.string().required(),
    bankAccountTypeCode: yup.string().optional(),
    accountNumber: yup.string().required(),
    routingNumber: yup.string().required(),
    isBusiness: yup.boolean().optional(),
})
    .required();
//# sourceMappingURL=eLockbox.js.map